export default function ChatgptSomeLinkedin() {
  return <h2>Chatgpt Some Linkedin</h2>;
}
